<template>
  <div :class="['app-input', { 'app-input--disabled': disabled, 'app-input--no-margin': noMargin }]">
    <label v-if="label" :for="inputId" class="app-input__label">
      {{ label }}<span v-if="required" class="app-input__required" aria-hidden="true">*</span>
    </label>
    <textarea
      v-if="multiline"
      :id="inputId"
      ref="input"
      class="app-input__field app-input__field--textarea"
      :value="localValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :rows="rows"
      :maxlength="maxlength"
      @input="onInput"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
    <input
      v-else
      :id="inputId"
      ref="input"
      class="app-input__field"
      :type="type"
      :value="localValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :maxlength="maxlength"
      :inputmode="inputmode"
      @input="onInput"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    >
  </div>
</template>

<script>
let uid = 0

export default {
  name: 'AppInput',
  inheritAttrs: false,
  props: {
    value: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    multiline: { type: Boolean, default: false },
    rows: { type: [Number, String], default: 2 },
    maxlength: { type: [Number, String], default: null },
    inputmode: { type: String, default: null },
    noMargin: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  data () {
    return {
      uid: `app-input-${++uid}`,
      localValue: this.value
    }
  },
  computed: {
    inputId () {
      return this.$attrs.id || this.uid
    }
  },
  watch: {
    value (newVal) {
      if (newVal !== this.localValue) this.localValue = newVal
    }
  },
  methods: {
    onInput (event) {
      const value = event.target.value
      this.localValue = value
      this.$emit('update:value', value)
      this.$emit('input', value)
    },
    focus () {
      if (this.$refs.input) this.$refs.input.focus()
    }
  }
}
</script>

<style scoped>
.app-input {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.85rem;
}

.app-input--no-margin {
  margin-bottom: 0;
}

.app-input__label {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #4f5560;
}

.app-input__required {
  margin-left: 0.2rem;
  color: #dc2626;
  font-weight: 700;
}

.app-input__field {
  width: 100%;
  height: 36px;
  padding: 0.3rem 0.6rem;
  border: 1px solid #d8dde6;
  border-radius: 8px;
  background: #ffffff;
  font-size: 0.85rem;
  color: #2f3640;
  font-family: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.app-input__field::placeholder {
  color: #9ca3af;
}

.app-input__field:focus {
  outline: none;
  border-color: #16a07a;
  box-shadow: 0 0 0 3px rgba(22, 160, 122, 0.18);
}

.app-input__field:disabled,
.app-input__field[readonly] {
  background: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
}

.app-input__field--textarea {
  height: auto;
  min-height: 64px;
  resize: vertical;
  line-height: 1.4;
}
</style>
